import { NodeType } from '@/features/screenplay/components/editor/nodes/NodeType'
import { EditorConfig, LexicalEditor, type NodeKey } from 'lexical'
import { BaseNode, SerializedBaseNode } from './BaseNode'
export class PageBreakNode extends BaseNode {
    next = null
    enableSuggestions = false
    pageNumber: number | undefined
    static getType(): string {
        return 'page-break'
    }

    static clone(node: PageBreakNode): PageBreakNode {
        return new PageBreakNode(node.id, node.__key)
    }

    constructor(id: string, key?: NodeKey) {
        super(id, key)
    }

    createHtmlElement(editor?: LexicalEditor): HTMLElement {
        const indexNo = this.findIndex()
        const dom = document.createElement('div')
        dom.className = 'pageBreak relative node-style-common'

        const content = document.createElement('span')
        content.className = 'content'

        const sceneIdSpan = document.createElement('div') // make it a block for layout
        sceneIdSpan.className = 'absolute right-[1in] text-right top-[0.5in] '
        sceneIdSpan.textContent = `${(indexNo ?? 0) + 2}`

        dom.append(sceneIdSpan, content)
        console.log(dom)
        return dom
    }

    debugClassAttachedDom(_editor?: LexicalEditor): HTMLElement {
        return this.createHtmlElement(_editor)
    }

    static importJSON(jsonNode: SerializedBaseNode): PageBreakNode {
        return new PageBreakNode(jsonNode.id)
    }

    static importDOM(): null {
        return null
    }
    findIndex(): number {
        const parent = this.getParent()
        if (!parent) return -1

        let idx = 0
        for (const child of parent.getChildren()) {
            if (child.getType() === NodeType.PageBreak) {
                if (child.is(this)) return idx
                idx++
            }
        }
        return -1
    }
    updateDOM(prevNode: PageBreakNode, dom: HTMLElement, config: EditorConfig): boolean {
        return true
    }
}
